import React from "react";
import PropTypes from "prop-types";
import { UncontrolledTooltip } from "reactstrap";
import info from "../../../client_customizations/assets/images/icons/info.svg";

const ToolTip = ({ id, message }) => {
  return (
    <>
      <img
        id={id}
        src={info}
        alt=""
        style={{ width: "16px", marginLeft: "5px", marginBottom: "3px" }}
      />
      <UncontrolledTooltip placement="right" target={id}>
        <span>{message}</span>
      </UncontrolledTooltip>
    </>
  );
};

export default ToolTip;

ToolTip.propTypes = {
  id: PropTypes.string,
  message: PropTypes.string,
};
